import { Box } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import toast from 'react-hot-toast';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';
import Scrollbar from '../../../components/Scrollbar';
import { invoiceTemplateColumns } from '../../../services/column-definitions';
import { downloadInvoiceTemplateAction } from '../../../services/request';
import ConfirmDeleteInvoiceTemplate from './ConfirmDeleteInvoiceTemplate';
import EditInvoiceTemplateModal from './EditInvoiceTemplateModal';

export default function InvoiceTemplateList({
  templates,
  queryCallback,
  setTemplates
}) {
  const [invoiceTemplate, setInvoiceTemplate] = React.useState({});
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const { query } = useParameterizedQuery(downloadInvoiceTemplateAction);

  const handleDownload = async row => {
    const { payload, error } = await query(row.id);

    if (!error) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${row.file_name}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }
  };

  const handleOpenDeleteModal = row => {
    setInvoiceTemplate(row);
    setOpenDeleteModal(true);
  };

  const handleOpenEditModal = row => {
    setInvoiceTemplate(row);
    setOpenEditModal(true);
  };

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <Scrollbar>
      <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
        <DataGridPro
          columns={invoiceTemplateColumns(
            handleDownload,
            handleOpenDeleteModal,
            handleOpenEditModal
          )}
          rows={templates}
          density="standard"
          disableColumnMenu={true}
          autoPageSize={false}
          autoHeight={true}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { miniView: true, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
        />
      </Box>
      {openDeleteModal ? (
        <ConfirmDeleteInvoiceTemplate
          invoiceTemplate={invoiceTemplate}
          handleClose={() => setOpenDeleteModal(false)}
          setTemplates={setTemplates}
        />
      ) : null}
      {openEditModal ? (
        <EditInvoiceTemplateModal
          invoiceTemplate={invoiceTemplate}
          handleClose={() => setOpenEditModal(false)}
          setTemplates={setTemplates}
        />
      ) : null}
    </Scrollbar>
  );
}

